(function () {
  var root = document.getElementById('DDPetRoot');
  if (!root) return;

  var KEY = 'dd_pet_v1';
  var SESSION_KEY = 'dd_pet_gate_done';
  var cfg = {
    inEditor: root.getAttribute('data-in-editor') === 'true',
    showInEditor: root.getAttribute('data-show-in-editor') === 'true',
    homeOnly: root.getAttribute('data-home-only') === 'true',
    template: root.getAttribute('data-template')
  };
  var ACC = [
    { id: 'band', label: 'Sweatband', at: 10 },
    { id: 'glasses', label: 'Cool shades', at: 30 },
    { id: 'crown', label: 'Hydration crown', at: 60 }
  ];
  var gate = document.getElementById('DDPetGate');
  var mini = document.getElementById('DDPetMini');
  var bonus = 0;

  function today() { return new Date().toDateString(); }

  function load() {
    var d = { points: 0, visit: '', hy: { day: '', n: 0 } };
    try {
      var raw = window.localStorage.getItem(KEY);
      if (raw) {
        var p = JSON.parse(raw);
        if (p && typeof p.points === 'number') { d = p; }
      }
    } catch (e) {}
    if (!d.hy) { d.hy = { day: '', n: 0 }; }
    return d;
  }

  var data = load();

  function save() { try { window.localStorage.setItem(KEY, JSON.stringify(data)); } catch (e) {} }
  function getFlag() { try { return window.sessionStorage.getItem(SESSION_KEY); } catch (e) { return null; } }
  function setFlag() { try { window.sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) {} }

  function accFor(points) {
    return ACC.filter(function (a) { return points >= a.at; }).map(function (a) { return a.id; }).join(' ');
  }

  function render() {
    var pets = root.querySelectorAll('[data-dd-pet]');
    for (var i = 0; i < pets.length; i++) { pets[i].setAttribute('data-acc', accFor(data.points)); }
    var pts = root.querySelectorAll('[data-dd-points]');
    for (var j = 0; j < pts.length; j++) { pts[j].textContent = data.points + ' pts'; }
    var info = root.querySelector('[data-dd-mini-info]');
    if (info && !info.getAttribute('data-busy')) { info.textContent = data.points + ' pts'; }
  }

  function unlocked(before, after) {
    return ACC.filter(function (a) { return before < a.at && after >= a.at; });
  }

  if (data.visit !== today()) {
    if (data.visit !== '') { bonus = 5; data.points += bonus; }
    data.visit = today();
    save();
  }
  render();

  function showMini() { if (mini) { mini.hidden = false; } }

  var search = '';
  try { search = window.location.search; } catch (e) {}
  var forced = search.indexOf('ddpet=1') !== -1;
  var allowedHere = !cfg.homeOnly || cfg.template === 'index';
  var editorOk = !cfg.inEditor || cfg.showInEditor;
  var shouldShow = !!gate && editorOk && (forced || (allowedHere && !getFlag()));

  if (mini) {
    var sipBtn = mini.querySelector('[data-dd-sip]');
    var miniPet = mini.querySelector('[data-dd-pet]');
    var miniInfo = mini.querySelector('[data-dd-mini-info]');
    var miniTimer = null;
    sipBtn.addEventListener('click', function () {
      var day = today();
      if (data.hy.day !== day) { data.hy = { day: day, n: 0 }; }
      var msg;
      if (data.hy.n >= 5) {
        msg = "I'm full! Come back tomorrow.";
      } else {
        var before = data.points;
        data.hy.n += 1;
        data.points += 1;
        save();
        var got = unlocked(before, data.points);
        msg = got.length ? 'New: ' + got[0].label + '!' : 'Thanks! +1 pt (' + data.hy.n + '/5 today)';
        render();
      }
      miniInfo.setAttribute('data-busy', '1');
      miniInfo.textContent = msg;
      miniPet.setAttribute('data-state', 'happy');
      window.clearTimeout(miniTimer);
      miniTimer = window.setTimeout(function () {
        miniInfo.removeAttribute('data-busy');
        miniInfo.textContent = data.points + ' pts';
      }, 2600);
    });
  }

  if (!shouldShow) { showMini(); return; }

  var pet = gate.querySelector('[data-dd-gate-pet]');
  var bubble = gate.querySelector('[data-dd-bubble]');
  var reward = gate.querySelector('[data-dd-reward]');
  var stage = gate.querySelector('[data-dd-stage]');
  var foods = gate.querySelectorAll('[data-dd-feed]');
  var skip = gate.querySelector('[data-dd-skip]');
  var busy = false;
  var closed = false;

  function sparkle() {
    for (var i = 0; i < 14; i++) {
      var s = document.createElement('span');
      s.className = 'dd-spark';
      var angle = Math.random() * Math.PI * 2;
      var dist = 70 + Math.random() * 90;
      s.style.setProperty('--dx', Math.round(Math.cos(angle) * dist) + 'px');
      s.style.setProperty('--dy', Math.round(Math.sin(angle) * dist) + 'px');
      stage.appendChild(s);
      (function (el) {
        window.setTimeout(function () { if (el.parentNode) { el.parentNode.removeChild(el); } }, 1200);
      })(s);
    }
  }

  function closeGate() {
    if (closed) return;
    closed = true;
    setFlag();
    gate.classList.add('is-leaving');
    document.documentElement.style.overflow = '';
    window.setTimeout(function () {
      gate.hidden = true;
      showMini();
    }, 650);
    window.setTimeout(function () {
      document.documentElement.removeAttribute('data-dd-pet-gate');
    }, 7000);
  }

  function feed(btn) {
    if (busy || closed) return;
    busy = true;
    for (var i = 0; i < foods.length; i++) { foods[i].disabled = true; }
    btn.classList.add('is-fed');
    pet.setAttribute('data-state', 'drinking');
    bubble.textContent = 'Glug glug glug...';
    window.setTimeout(function () {
      var before = data.points;
      data.points += 10;
      save();
      pet.setAttribute('data-state', 'happy');
      bubble.textContent = root.getAttribute('data-happy') || 'Energized! Let\u2019s go!';
      render();
      sparkle();
      var text = '+10 points' + (bonus ? ' \u00b7 +' + bonus + ' welcome-back bonus' : '');
      var got = unlocked(before, data.points);
      if (got.length) { text += ' \u00b7 Unlocked: ' + got[0].label + '!'; }
      reward.textContent = text;
      window.setTimeout(closeGate, 2600);
    }, 1000);
  }

  for (var k = 0; k < foods.length; k++) {
    (function (b) { b.addEventListener('click', function () { feed(b); }); })(foods[k]);
  }
  skip.addEventListener('click', closeGate);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !closed) { closeGate(); }
  });
  document.addEventListener('focusin', function (e) {
    if (!closed && !gate.hidden && !gate.contains(e.target)) {
      var first = gate.querySelector('button:not([disabled])');
      if (first) { first.focus(); }
    }
  });

  document.documentElement.setAttribute('data-dd-pet-gate', '1');
  document.documentElement.style.overflow = 'hidden';
  gate.hidden = false;
  var firstFood = gate.querySelector('[data-dd-feed]');
  if (firstFood) { firstFood.focus(); } else { skip.focus(); }
})();